import { takeLatest, call, put } from 'redux-saga/effects';
import { createAction } from '@reduxjs/toolkit';
import request from '../../Utils/Request';
import { storeInferences } from './RuntimeHistory.reducer';
import {
  enableExportLoader,
  enableLoader,
  showMessageToast,
} from '../Login/Login.reducer';
import { makeUndefined } from '../../Utils/validationUtil';

export const fetchInferences = createAction('FETCH_INFERENCES');
export const runtimeExport = createAction('EXPORT_RUNTIME');

function* getInferenceList(action) {
  const { params } = action.payload;
  const conditionCheck =
    params.sortBy === '' &&
    params.sortDirection === '' &&
    params.searchValue === '';
  try {
    if (conditionCheck) yield put(enableLoader(true));
    const payload = makeUndefined(params);
    const response = yield call(request, '/rest/runtime-inference/history', {
      data: payload,
      action,
    });
    if (response.status === 200 && response.entity) {
      yield put(storeInferences(response.entity));
    }
    if (conditionCheck) yield put(enableLoader(false));
  } catch (error) {
    if (conditionCheck) yield put(enableLoader(false));
    yield put(
      showMessageToast({
        show: true,
        message: error.message
          ? error.message
          : 'Fetching inference history unsuccessful',
        type: 'error',
      })
    );
  }
}
function* exportModel(action) {
  try {
    yield put(
      enableExportLoader({
        loader: true,
        id: action.payload,
      })
    );
    const response = yield call(
      request,
      `/rest/training/model/exportRuntime?runtimeId=${action.payload}`,
      {
        method: 'POST',
        action,
      }
    );
    if (response.status === 200) {
      if (response.entity) {
        const a = document.createElement('a');
        a.setAttribute('href', response.entity);
        a.setAttribute('target', '_blank');
        a.setAttribute('download', response.entity.split('/')[2]);
        a.style.display = 'none';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      }
    }
    yield put(enableExportLoader({ loader: false, id: action.payload }));
  } catch (error) {
    yield put(enableExportLoader({ loader: false, id: action.payload }));
    yield put(
      showMessageToast({
        show: true,
        message: error.message ? error.message : 'Exporting Model unsuccessful',
        type: 'error',
      })
    );
  }
}

export default function* runtimeHistorySaga() {
  const watcher = [];
  watcher.push(yield takeLatest(fetchInferences.toString(), getInferenceList));
  watcher.push(yield takeLatest(runtimeExport.toString(), exportModel));
}
